module.exports = __webpack_public_path__ + "img/kasetsart-vet.c150718b.png";